(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalNegotiationContent", modalNegotiationContent);

    /** @ngInject */
    function modalNegotiationContent() {
        return {
            restrict: "E",
            scope: {
                negotiationId: "=",
                column: "=",
                columns: "=",
                isImmoContext: "=",
                onClose: "&",
                onExpose: "&",
                response: "=",
                isValid: "=",
                submitLoading: "=",
                isFormInvalid: "&"
            },
            controller: 'ModalNegotiationContentController',
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/negotiation/modal-negotiation-content.html",
            link: function (scope, element, attrs, ctrl) {
                if (ctrl && typeof scope.vm.onExpose === 'function') {
                    scope.vm.onExpose({ methods: { applyFilters: ctrl.submit, closeModal: ctrl.close, isFormInvalid: ctrl.isFormInvalid } });
                }
            }
        };


    }
})();
